export const getIssues = state => state.issue.issuesList;
export const getSupportedIssues = state => state.issue.supportedIssuesList;
export const getSupports = state => state.issue.reportSupports;
export const getIssueDetails = state => state.issue.issueDetails;
export const getIssueCounts = state => state.issue.counts;
